import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiUrl } from "../apiUrl"; // Asegúrate de que la ruta sea correcta

// Async Thunk para obtener todos los templates
export const getAllTemplates = createAsyncThunk(
  "templates/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${apiUrl}/api/v1/templates`);
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error.message);
    }
  }
);

const templateSlice = createSlice({
  name: "templates",
  initialState: {
    data: [],
    isLoading: false,
    error: null,
    lastFetched: null
  },
  reducers: {
    // Reducer para resetear el estado
    resetTemplates: (state) => {
      state.data = [];
      state.error = null;
      state.lastFetched = null;
    },
    // Reducer para agregar un template manualmente (opcional)
    addTemplate: (state, action) => {
      state.data.unshift(action.payload);
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllTemplates.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAllTemplates.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.lastFetched = new Date().toISOString();
      })
      .addCase(getAllTemplates.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || {
          message: "Error al cargar los templates"
        };
      });
  }
});

// Exporta las acciones síncronas
export const { resetTemplates, addTemplate } = templateSlice.actions;

// Exporta el reducer
export default templateSlice.reducer;